import area from "@turf/area";
import { featureCollection } from "@turf/helpers";
import intersect from "@turf/intersect";
import union from "@turf/union";
import { PropertyInfoInterface } from "src/managers/PropertyInfoInterface";

export type MarkIntersect = {
   type: string;
   properties: {
      id: number;
      name: string;
      area: number;
      overlap: number;
      [key: string]: any | undefined;
   };
   intersect: {
      type: string;
      coordinates: number[][][] | number[][] | number[];
   }
   geometry: {
      type: string;
      coordinates: number[][][] | number[][] | number[];
   };
}
export class MarkData {

   static async getMarkData(geojson: any) {
      let res = await PropertyInfoInterface.getMarkData(geojson);
      if (res) {
         return res;
      } else {
         return null;
      }
   }

   static async hentMarkerIndenforFeatureCollection<T extends { geometry, properties }>(collection: { features: T[] }): Promise<T & { marker?: MarkIntersect[] }> {
      let combined = collection.features[0] as any
      if (collection.features.length > 1) {
         combined = union(collection as any);
      }
      return await this.hentMarkerIndenforFeature(combined as any);
   }

   static async hentMarkerIndenforFeature<T extends { geometry, properties }>(geojson: T): Promise<T & { marker?: MarkIntersect[] }> {
      let sfe = window.structuredClone(geojson);
      let resMark = await this.getMarkData(sfe.geometry);
      if (resMark) {
         let overlap: any[] = []
         resMark.features.forEach(mark => {
            let intersection = intersect(featureCollection([mark, sfe]))
            if (intersection) {
               mark.properties.overlap = area(intersection)
               mark.properties.area = area(mark.geometry);
               mark.intersect = intersection.geometry;
               overlap.push(mark);
            }
         });
         sfe["marker"] = overlap;
      }
      return sfe;
   }

   static async hentMarkerFraSFEListe(liste: { sfe: number }[]): Promise<any[]> {
      let x = Promise.all(liste.map(async (a) => {
         return (await PropertyInfoInterface.getGeojsonOfSFE(a.sfe))
      }));
      let y = (await x).map(async (val) => { return await this.hentMarkerIndenforFeature(val.features.length > 1 ? union(val, { ...val.features[0] }) : val.features[0]) });
      let data = await Promise.all(y)
      return data;
   }

   static haFormat(): (nr: number) => { format: string, unit: string } {
      let ha = Intl.NumberFormat("da-DK", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      let m2 = Intl.NumberFormat("da-DK", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return (nr: number) => {
         if (nr > 100) {
            return { format: ha.format(nr / 10000) + " ha", unit: "ha" }
         }
         return { format: m2.format(nr) + " m²", unit: "m²" }
      }
   }
}
